/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { entity } from 'projects/icemedx-lib/src/models/common/entity';
import { contact } from '../common/contact';
import { address } from '../common/address';
import { identification } from '../common/identification';
import { basecode } from '../ehr/subs/basecode';
import { patient } from './patient';
import { dependentreference } from '../ehr/subs/dependentreference';
import { coverage } from '../ehr/subs/coverage';
import { IceTypes } from '../icetypes';

export class subscriber extends patient {
  subscriber_key: string = "";
  patient_trans_account: string = "";
  relationship_code: string = "";
  plan_name: string = "";
  insurance_type_code: string = "";
  claim_filing_indicator_code: string = "";
  last_known_date: any = NaN;
  last_known_copay: number = 0.0;
  last_known_annual_deductible: number = 0.0;
  last_known_annual_deductible_accum: number = 0.0;
  method_of_verification: number = 0;
  mov_eligibility_list_date: any = NaN;
  mov_member_services_contact: string = "";
  mov_ipa_office: string = "";
  mov_other: string = "";
  termination_date: any = NaN;
  effective_date: any = NaN;
  pcp_info: string = "";
  benefits: string = "";
  connection_parameters_key: string = "";
  request_message_key: string = "";
  request_message_date: any = NaN;
  request_message_status: number = IceTypes.trans_status.isNone;
  response_message_key: string = "";
  response_message_date: any = NaN;
  response_message_status: number = IceTypes.trans_status.isNone;
  response_message_log: string = "";

  DEPS: dependentreference[] = [];
  COVGS: coverage[] = [];

  gettablename(): string {
    return "SUBSCRIBER";
  }

  hassubtree(ColumnName: string): boolean {
    if (ColumnName.length == 0) return false;
    else if (ColumnName == "DEPS") return true;
    else if (ColumnName == "COVGS") return true;

    return super.hassubtree(ColumnName);
  }

  getsubtreetablename(ColumnName: string): string {
    if (ColumnName.length == 0) return null;
    else if (ColumnName == "DEPS") return "DEPENDENT_REFERENCE";
    else if (ColumnName == "COVGS") return "COVERAGE";

    return super.getsubtreetablename(ColumnName);
  }
}
